(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('EmailService', EmailService);

  EmailService.$inject = ['$resource'];

	 function EmailService ($resource) {
    return $resource(apiUrl + '/emails-config/:id', { id: '@id' }, {
      all: { url: apiUrl + '/emails-config-all', method: 'GET', params: {}, isArray: true },
      configForActiveEmail: { url: apiUrl + '/get-active-emails-config', method: 'GET', params: {}, isArray: false },
      create: { method: 'POST', params: {}, isArray: false },
      createActiveEmail: { url: apiUrl + '/create-active-email/:id', method: 'POST', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false },
      update: { method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      find: { method: 'GET', params: {}, isArray: false },
      findOne: { method: 'GET', params: {}, isArray: true }
    });
  }
})();
